import { JSX, useCallback } from "react";
import { useTranslation } from "react-i18next";

import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";

const LANGUAGES = ["nl", "en"];

export default function LanguageSelector(): JSX.Element {
	const { i18n } = useTranslation();

	const setLanguage = useCallback(
		(event: SelectChangeEvent): void => {
			i18n.changeLanguage(event.target.value);
		},
		[i18n]
	);

	return (
		<FormControl
			variant="outlined"
			sx={{
				"& .MuiInputLabel-root": { color: "white" },
				"& .MuiOutlinedInput-root": {
					"& fieldset": { border: "none" },
					"&:hover fieldset": { border: "none" },
					"&.Mui-focused fieldset": { border: "none" },
					"& .MuiSelect-icon": { color: "white" }
				},
				"& .MuiSelect-select": { color: "white" }
			}}>
			<Select value={i18n.language} onChange={setLanguage}>
				{LANGUAGES.map(language => (
					<MenuItem key={language} value={language}>
						{language}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
}
